module.exports = __webpack_public_path__ + "img/Blinking_by_Product.c5316f49.svg";